import { Card, Spin, Typography } from "antd";
import React from "react";
import Chart from "react-apexcharts";

export default function RetentionChart({ data, loading, offices }) {
  if (!data || data.length === 0)
    return (
      <div>
        {" "}
        {/* 👈 breaks margin collapse */}
        <Typography style={{ fontSize: 21, fontWeight: 600, marginBottom: 21 }}>User Retention & Churn Analysis</Typography>
        <Card>{loading ? <Spin /> : "No Retention Data Available"}</Card>
      </div>
    );

  const retention_data = data.retention_data; // accordin to abbas data
  // Test retention data
  // const retention_data = [
  //   {
  //     retention: [100, 70, 40, 30],
  //     tags: ["May06-Jun06", "Jun06-Jul06", "Jul06-Aug06", "Aug06-Sep06"]
  //   },
  //   {
  //     retention: [100, 80, 70],
  //     tags: ["Jun06-Jul06", "Jul06-Aug06", "Aug06-Sep06"]
  //   },
  //   {
  //     retention: [100, 50],
  //     tags: ["Jul06-Aug06", "Aug06-Sep06"]
  //   },
  //   {
  //     retention: [100],
  //     tags: ["Aug06-Sep06"]
  //   }
  // ];

  // Transform data for the chart
  const series = retention_data.map((group, groupIndex) => {
    // Calculate x-position for each group (evenly spaced)
    const groupSpacing = 1;
    const groupCenter = groupIndex * groupSpacing;

    // Calculate x-positions for points within the group
    const pointData = group.retention.map((value, pointIndex) => {
      // Distribute points within the group
      const pointOffset = (pointIndex - ((group.tags ? group.tags.length : 0) - 1) / 2) * 0.2;
      return {
        x: groupCenter + pointOffset,
        y: value,
      };
    });

    // Create group name from first and last tag
    const groupName =
      group.tags && group.tags.length > 0
        ? `${group.tags[0].split("-")[0]}-${group.tags[group.tags.length - 1].split("-")[1]}`
        : `Group ${groupIndex + 1}`;

    return {
      name: groupName,
      data: pointData,
    };
  });

  // Generate custom x-axis labels (all tags)
  const allTags = [];
  retention_data.forEach((group, groupIndex) => {
    const groupSpacing = 1;
    const groupCenter = groupIndex * groupSpacing;

    group.tags &&
      group.tags.forEach((tag, tagIndex) => {
        const pointOffset = (tagIndex - (group.tags.length - 1) / 2) * 0.2;
        allTags.push({
          x: groupCenter + pointOffset,
          text: tag,
        });
      });
  });

  // Chart options
  const options = {
    chart: {
      type: "line",
      height: 400,
      toolbar: {
        show: false,
      },
    },
    colors: ["#008FFB", "#00E396", "#FEB019", "#FF4560"],
    markers: {
      size: 6,
      strokeWidth: 0,
      hover: {
        size: 9,
      },
    },
    stroke: {
      // 👇 Dynamically set stroke width: 0 if only 1 point, else 2
      width: series.map((s) => (s && s.data && s.data.length === 1 ? 0 : 2)),
      curve: "straight",
    },

    xaxis: {
      type: "numeric",
      labels: {
        formatter: function (value) {
          return "";
        },
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
    yaxis: {
      min: 0,
      max: 100,
      labels: {
        formatter: function (value) {
          return value + "%";
        },
      },
    },
    grid: {
      padding: {
        right: 30,
        left: 20,
      },
    },
    annotations: {
      xaxis: allTags.map((tag) => ({
        x: tag.x,
        label: {
          text: tag.text,
          position: "front",
          orientation: "vertical",
          textAnchor: "middle",
          borderWidth: 0, // 👈 removes border completely
          offsetY: 20, // closer to x-axis
          offsetX: 10, // 👈 adjust this if labels hug the y-axis too much
          style: {
            color: "#333",
            fontSize: "10px",
            background: "transparent", // no box background
          },
        },
      })),
    },
    tooltip: {
      custom: function ({ seriesIndex, dataPointIndex, w }) {
        const group = retention_data[seriesIndex];
        const value = group.retention[dataPointIndex];
        const tag = group.tags[dataPointIndex];
        return `
          <div class="apexcharts-tooltip-box" style="padding: 5px; background: #fff; border: 1px solid #ddd;">
            <div><strong>${tag}</strong></div>
            <div>Retention: ${value}%</div>
          </div>
        `;
      },
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "left",
      offsetY: 2, // 👈 gives a little spacing below the x-axis
    },
  };

  if (offices && offices.length === 0)
    return (
      <div style={{ paddingTop: 1 }}>
        {" "}
        {/* 👈 breaks margin collapse */}
        <Typography style={{ fontSize: 21, fontWeight: 600, marginBottom: 21 }}>User Retention & Churn Analysis</Typography>
        <Card>Please, select at least one office.</Card>
      </div>
    );

  return (
    <div style={{ paddingTop: 1 }}>
      {" "}
      {/* 👈 breaks margin collapse */}
      <Typography style={{ fontSize: 21, fontWeight: 600, marginBottom: 21 }}>User Retention & Churn Analysis</Typography>
      <Card>{loading ? <Spin /> : <Chart options={options} series={series} type="line" height={300} width="100%" />}</Card>
    </div>
  );
}
